export default {
    getTime(val) {
        var newTime = new Date().getTime()
        var oldTime = new Date(val).getTime()
        var timeSlot = newTime - oldTime
        var second = 0
        var divide = 0
        var hours = 0
        if (Math.floor(timeSlot / 1000) < 60) {
            second = Math.floor(timeSlot / 1000)
        } else {
            if (Math.floor(timeSlot / 1000 / 60) < 60) {
                if (Math.floor(timeSlot / 1000) == 60) {
                    divide = 1 + '分钟前'
                } else {
                    divide = Math.floor(timeSlot / 1000 / 60) + '分钟前'
                }
            } else {
                if (Math.floor(timeSlot / 1000 / 60 / 60) < 24) {
                    hours = Math.floor(timeSlot / 1000 / 60 / 60) + '小时前'
                } else if (Math.floor(timeSlot / 1000 / 60 / 60) == 24) {
                    hours = '一天前'
                }
            }
        }
        return second!=0?second:divide!=0?divide:hours!=0?hours:val.split(' ')[0]
    }
}



// WEBPACK FOOTER //
// ./src/common/js/common.js